<template>
  <wegow-select
    :id="id"
    :options="venues.venues"
    :value="optionSelected"
    :loading="loadingVenues"
    :background-select="backgroundSelect"
    :placeholder="placeholder || $t('general.forms.inputSearchPlaceholder')"
    :label="label"
    :description="description"
    :no-options-label="$t('general.forms.noOptionsLabel')"
    :no-result-label="$t('general.forms.noResultLabel')"
    object-label="name"
    :error-message="errorMessage"
    :removable="removable"
    :multiple="multiple"
    :disabled="disabled"
    :special-label="true"
    :track-by="trackBy"
    :make-server-call="true"
    :padding="padding"
    border="1px solid #7F8295"
    :height="height"
    @search-change="getVenuesSearch"
    @select="selectVenue"
    @remove="removeVenue"
  >
    <template #option="data">
      {{ data.data.option.name }} <br />
      <small class="subtitle mt-4">
        {{ data.data.option.address }}
        <span v-if="data.data.option.city">
          (
          <span v-if="data.data.option.city.name">
            {{ data.data.option.city.name }},
          </span>
          <span v-if="data.data.option.city.administrative_division">
            {{ data.data.option.city.administrative_division }},
          </span>
          <span v-if="data.data.option.city.country">
            {{ data.data.option.city.country }},
          </span>
          )
        </span>
      </small>
    </template>
  </wegow-select>
</template>

<script setup>
import { useVenue } from "@/composables/useVenue";

import WegowSelect from "@/components/general/forms/WegowSelect";
import { computed, ref, onMounted } from "vue";

const { venues, getVenues } = useVenue();

const props = defineProps({
  id: { type: String, required: false, default: "" },
  optionSelected: {
    type: [String, Object, Array],
    required: false,
    default: ""
  },
  trackBy: { type: String, required: false, default: "id" },
  label: { type: String, required: false, default: "" },
  description: { type: String, required: false, default: "" },
  placeholder: { type: String, required: false, default: "" },
  errorMessage: { type: String, required: false, default: "" },
  removable: { type: Boolean, required: false, default: false },
  multiple: { type: Boolean, required: false, default: false },
  disabled: { type: Boolean, required: false, default: false },
  backgroundSelect: {
    type: String,
    default: ""
  },
  padding: {
    type: String,
    default: "unset"
  },
  height: {
    type: String,
    default: ""
  }
});
const emit = defineEmits(["setValue", "onSelect", "onRemove"]);

const loadingVenues = ref(false);
// let requestVenue = null;
let debounce = null;

const getVenuesSearch = search => {
  if (debounce) clearTimeout(debounce);
  loadingVenues.value = true;
  debounce = setTimeout(async () => {
    // if (requestVenue) {
    //   requestVenue.cancel();
    //   requestVenue = null;
    // }
    // const axiosSource = axios.CancelToken.source();
    // requestVenue = { cancel: axiosSource.cancel, msg: "Loading..." };

    // let params = {
    //   query: search,
    //   page: 1,
    //   page_size: 50,
    //   ...props.specialParams
    // };
    await getVenues(search);
    // await store.dispatch("global/getVenues", params);
    loadingVenues.value = false;
    // requestVenue = null;
  }, 500);
};

const selectVenue = async value => {
  emit("onSelect", value);
  await getVenues();
};

const removeVenue = $event => {
  emit("onRemove", $event);
};

onMounted(async () => {
  if (!props.disabled) {
    if (venues.value.length === 0) {
      await getVenues();
    }
  }
});
</script>

<style scoped>
.subtitle {
  color: rgba(255, 255, 255, 0.5);
  font-size: 85%;
}
</style>
